import LearningSection from 'LearningManager/components/LearningSection';
import { learningPaths } from 'LearningManager/constants/createAssignment.constant';
import styles from 'LearningManager/styles/QuickSetup.module.scss';

const slugify = (value: string) =>
	value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');

const LearningPath: React.FC = () => {
	return (
		<div id="lms-ca-learning-path" className={styles.learningPath}>
			<div
				id="lms-ca-learning-path-heading"
				className={styles.learningPath__heading}
			>
				Learning Path Review
			</div>
			<div className={styles.learningPath__desc__container}>
				<div className={styles.learningPath__desc}>
					Quick setup automatically assigns learning paths based on
					employee roles.
				</div>
				<div className={styles.learningPath__desc}>
					Venza offers comprehensive awareness training through three
					curated learning paths: Basic, Intermediate, and Advanced.
					Each curriculum consists of a series of individual courses
					that are carefully designed to provide a standard-setting
					training experience.
				</div>
				<div className={styles.learningPath__desc}>
					Staff receive the Basic Learning Path, Managers receive the
					Basic and Intermediate Paths, and Leadership + IT receive
					all three paths.
				</div>
			</div>

			<div
				id="lms-ca-learning-path-sections"
				className={styles.learningPath__wrapper}
			>
				{learningPaths.map((section) => (
					<LearningSection
						key={section.title}
						id={`lms-ca-learning-section-${slugify(section.title)}`}
						{...section}
						courses={section.courses}
					/>
				))}
			</div>
		</div>
	);
};

export default LearningPath;
